import React, {useEffect, useState} from 'react';
import QuadralTextField from '@quadral/quadral-component-common/dist/components/textField';
import QuadralAutocomplete from '@quadral/quadral-component-common/dist/components/autocomplete';
import QuadralCheckbox from '@quadral/quadral-component-common/dist/components/checkbox';
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import { purchaseOrdersService } from '../../services';

const optionStatus = [
    {label: "Nouvelle"},
    {label: "En attente infos"},
    {label: "En cours"},
    {label: "Livrée"},
    {label: "Annulée"}
]

const PurchaseOrderSearchForm = (props) => {
    const [valueStatus, setValueStatus] = useState([]);
    const [valueDiagnostician, setValueDiagnostician] = useState("");
    const [resultsDiagnostician, setResultsDiagnostician] = useState([]);
    const [valueContact, setValueContact] = useState("");
    const [resultsContact, setResultsContact] = useState([]);

    const managementUnitByCompany = props.managementUnit?.managementUnitByCompany || {};

    const optionCompanies = Object.values(managementUnitByCompany).flat();

    let sourceItems = optionCompanies.map(company => ({
        label: company.managementUnitName,
        value: company.managementUnitId
    }));

    useEffect(() => {
        diagnosticianAutocomplete(valueDiagnostician);
    }, [valueDiagnostician]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        contactAutocomplete(valueContact);
    }, [valueContact]); // eslint-disable-line react-hooks/exhaustive-deps

    function resetForm(event) {
        event.preventDefault();

        props.setSearchFormData(({
            orderNumber: '',
            street: '',
            billingZipCode: '',
            city: '',
            status: [],
            diagnostician: '',
            contact: '',
            managementUnitIds: [],
            customerReference: '',
            sort: {
                field: "effectiveDate",
                direction: "DESC"
            },
            pagination: {
                limit: 25,
                offset: 0
            }
        }));

        setValueDiagnostician('');
        setValueContact('');
        setValueStatus([]);
        props.setCheckboxValue(false);
    }

    function diagnosticianAutocomplete(diagnostician) {
        purchaseOrdersService.findAutocompleteDiagnosticians(diagnostician)
            .then(data => setResultsDiagnostician(data))
            .catch(err => {
                console.error(err);
                props.hideLoader();
            });
    }

    function contactAutocomplete(contact) {
        purchaseOrdersService.findAutocompleteContact(contact)
            .then(data => setResultsContact(data))
            .catch(err => {
                console.error(err);
                props.hideLoader();
            });
    }

    const render = () => (
        <>
            <form onSubmit={props.search}>
                <div justify="start">
                    <div col sm={6} md={2}>
                        <QuadralTextField
                            label="Ref Quadral"
                            name="orderNumber"
                            value={props.searchFormData.orderNumber}
                            onChange={(value) => props.handleField('orderNumber', value)}
                        />
                    </div>
                    <div col sm={6} md={2}>
                        <QuadralTextField
                            label="Ref client"
                            name="customerReference"
                            value={props.searchFormData.customerReference}
                            onChange={(value) => props.handleField('customerReference', value)}
                        />
                    </div>
                    <div sm={6} md={3}>
                        <div>
                            <QuadralAutocomplete
                                label="Status"
                                id="status"
                                name="status"
                                multiple
                                options={optionStatus.map(o => o.label)}
                                value={valueStatus}
                                onChange={(event, newValue) => {
                                    setValueStatus(newValue);
                                    props.handleField('status', newValue);
                                }}
                            />
                        </div>
                    </div>
                    <div sm={6} md={3}>
                        <div>
                            <QuadralAutocomplete
                                id="autocomplete-diagnostician"
                                name="diagnostician"
                                options={resultsDiagnostician.map(c => c.name)}
                                value={valueDiagnostician}
                                onInputChange={(event, newInputValue) => setValueDiagnostician(newInputValue)}
                                onChange={(event, newValue) => {
                                    setValueDiagnostician(newValue || "");
                                    if (newValue) {
                                        const diagnostician = resultsDiagnostician.find(c => c.name === newValue);
                                        if (diagnostician) props.handleField('diagnostician', diagnostician.name);
                                    }
                                }}
                                label="Diagnostiqueur"
                            />
                        </div>
                    </div>
                    <div sm={6} md={2}>
                        <div>
                            <QuadralAutocomplete
                                id="autocomplete-contact"
                                name="contact"
                                options={resultsContact.map(c => c.name)}
                                value={valueContact}
                                onInputChange={(event, newInputValue) => setValueContact(newInputValue)}
                                onChange={(event, newValue) => {
                                    setValueContact(newValue || "");
                                    if (newValue) {
                                        const contact = resultsContact.find(c => c.name === newValue);
                                        if (contact) props.handleField('contact', contact.id);
                                    }
                                }}
                                label="Contact"
                            />
                        </div>
                    </div>
                </div>
                <div justify="start">
                    <div sm={6} md={4}>
                        <QuadralTextField
                            label="Adresse"
                            name="street"
                            value={props.searchFormData.street}
                            onChange={(value) => props.handleField('street', value)}
                        />
                    </div>
                    <div sm={6} md={2}>
                        <QuadralTextField
                            label="Code postal"
                            name="billingZipCode"
                            value={props.searchFormData.billingZipCode}
                            onChange={(value) => props.handleField('billingZipCode', value)}
                        />
                    </div>
                    <div sm={6} md={3}>
                        <QuadralTextField
                            label="Ville"
                            name="city"
                            value={props.searchFormData.city}
                            onChange={(value) => props.handleField('city', value)}
                        />
                    </div>
                    <div sm={6} md={3} className="align-self-center">
                        <div sm={6} md={3} className="align-self-center">
                            {sourceItems.length > 0 ? (
                                <QuadralAutocomplete
                                    label="Unité de gestion"
                                    id="managementUnitIds"
                                    name="managementUnitIds"
                                    multiple
                                    options={sourceItems.map(o => o.label)}
                                    value={props.searchFormData.managementUnitIds.map(id => {
                                        const match = sourceItems.find(s => s.value === id);
                                        return match ? match.label : null;
                                    }).filter(Boolean)}
                                    onChange={(event, newValue) => {
                                        const selectedIds = newValue.map(label => {
                                            const match = sourceItems.find(s => s.label === label);
                                            return match ? match.value : null;
                                        }).filter(Boolean);
                                        props.handleField('managementUnitIds', selectedIds);
                                    }}
                                />
                            ) : (
                                <span></span>
                            )}
                        </div>
                    </div>
                </div>
                <div justify="between">
                    <div className="result-div col-md-6 col-md-4 col-sm-6">
                        <QuadralCheckbox
                            className=""
                            aria-label="Avec rapports à valider"
                            checked={props.checkboxValue}
                            onChange={() => {
                                props.setCheckboxValue(val => !val);
                            }}
                            label="Avec rapports à valider"
                        />
                    </div>
                    <div className="d-grid justify-content-end align-items-center">
                        <div>
                            <QuadralButton className={"btn btn-outline-secondary btn-outline-borderless"} type="button"
                                           onClick={resetForm}>
                                <span className={"inline-item inline-item-before"}>
                                    <i className='fa-regular fa-xmark icon-color-primary'></i>
                                </span>
                                {"Réinitialiser"}
                            </QuadralButton>
                            <QuadralButton className={"btn btn-outline-primary"} type="submit" onClick={props.search}>
                                <span className={"inline-item inline-item-before"}>
                                    <i className='fa-regular fa-magnifying-glass icon-color-primary'></i>
                                </span>
                                {"Rechercher"}
                            </QuadralButton>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );

    return render();
}

export default PurchaseOrderSearchForm;